<div
  class="p500-ui-form-field p500-ui-form-field--radio-field-with-label"
  [class.p500-ui-form-field--disabled]="disabled"
  [class.p500-ui-form-field--required]="requiredValidator"
>
  @if (showLabel) {
  <span class="p500-ui-form-field__label-inner mb-10">
    <ng-template
      [ngTemplateOutlet]="labelTpl || defaultTpl"
      [ngTemplateOutletContext]="{ disabled, label, required: requiredValidator, invalid }"
    ></ng-template>
    <ng-template #defaultTpl>
      <span class="p500-ui-form-field__label">{{ label }}</span>
    </ng-template>
  </span>
  } @else {
  <span class="p500-ui-form-field__label-inner mb-4"></span>
  }
  <label class="p500-ui-form-field__inner ml-auto">
    <input type="checkbox" [ngModel]="data" (ngModelChange)="changeData($event)" [disabled]="disabled" class="p500-ui-form-field__input" />
    <span class="p500-ui-form-field__label-inner">
      <span class="p500-ui-form-field__label"></span>
    </span>
  </label>
</div>
